export enum SexoBeneficiario {
  Masculino,
  Feminino,
}
